import styled from 'styled-components'
import ReactGA from 'react-ga4'

const BannerHref = styled.div`
  display: inline;
  overflow: hidden;
  touch-action: pan-x; /* 수직 스크롤 방지, 수평 이동만 허용 */
  user-select: none; /* 텍스트 선택 방지 */
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  touch-action: pan-x; /* 수직 스크롤 방지, 수평 이동만 허용 */
  -webkit-user-drag: none; /* 드래그 방지 */
  user-select: none; /* 텍스트 선택 방지 */
`;

function DefaultBanner({ gaPage, name, eventHref, image, language }) {
  if (!image[language]) {
    return null;
  }

  // 언어별 href 처리
  const getLocalizedHref = () => {
    // eventHref가 객체인 경우 (언어별 다른 링크)
    if (typeof eventHref === 'object' && eventHref[language]) {
      return eventHref[language];
    }
    // 기존 문자열인 경우
    return eventHref;
  }

  // 언어별 image 처리
  const getLocalizedImage = () => {
    // image가 객체인 경우 (언어별 다른 이미지)
    if (typeof image === 'object' && image[language]) {
      return image[language];
    }
    // 기존 문자열인 경우
    return image;
  }

  const onClickHrefDiv = () => {
    // 페이지 클릭 시 GA Event
    ReactGA.event({
      action:`Page Clicked_${gaPage}_${name}`,
      category: 'Banner Click',
      label: language || 'default'
    });
    
    // window.location.href = href;
    window.location.href = getLocalizedHref();
  }

  return (
    <BannerHref onClick={onClickHrefDiv}>
      <BannerImage src={getLocalizedImage()} alt={`${name}_${language}`} />
    </BannerHref>
  )
}

export default DefaultBanner;
